// STORY_HEADLINE_COPY is the only landing story headline map.
// LANDING_HERO_HEADLINE and LANDING_HERO_SUBHEAD stay the default hero.
// Callers should not hardcode story lines.

import { withIncomingSearch } from "./landingQuery";
import { normalizeStory } from "./marketingAttribution";

export const LANDING_HERO_HEADLINE =
  "Experience travel without the hassle of planning.";

export const LANDING_HERO_SUBHEAD =
  "Dople learns your preferences and lifestyle, then builds itineraries around the restaurants, shops, and moments that match your life.";

export const LANDING_HEADLINE_VARIANT_PROPERTY = "landing_headline_variant";
export const LANDING_HEADLINE_FALLBACK_VARIANT = "default";

export const STORY_HEADLINE_COPY = {
  contrast: {
    headline: "Not the same ChatGPT itinerary everyone else gets.",
    subhead: "Dople plans each day around how you actually travel. Answer a few questions and get a trip built for you.",
  },
  itinerary: {
    headline: "Your day-by-day itinerary, built around your taste.",
    subhead: "Not a generic list. Tell Dople how you travel and get every day planned, from Copenhagen to anywhere.",
  },
  outcome: {
    headline: "The meals, shops and moments you'll still talk about.",
    subhead: "Dople plans each day around your taste, so the trip feels like yours, not a list.",
  },
};

export const STORY_SAMPLE_PATH = "/samples/copenhagen-bornholm-12-day";
export const STORY_SAMPLE_LINK_LABEL = "See the 12-day Copenhagen and Bornholm sample";

export function currentLandingSearch() {
  if (typeof window === "undefined") return "";
  try {
    return window.location.search || "";
  } catch {
    return "";
  }
}

export function landingHeadlineVariant(search) {
  const story = normalizeStory(
    new URLSearchParams(String(search || "").replace(/^\?/, "")).get("story")
  );
  if (Object.prototype.hasOwnProperty.call(STORY_HEADLINE_COPY, story)) return story;
  return LANDING_HEADLINE_FALLBACK_VARIANT;
}

export function landingHeadlineCopy(search) {
  const variant = landingHeadlineVariant(search);
  const row = Object.prototype.hasOwnProperty.call(STORY_HEADLINE_COPY, variant)
    ? STORY_HEADLINE_COPY[variant]
    : null;
  return {
    variant,
    headline: row ? row.headline : LANDING_HERO_HEADLINE,
    subhead: row ? row.subhead : LANDING_HERO_SUBHEAD,
  };
}

export function storySampleHref(search) {
  return withIncomingSearch(STORY_SAMPLE_PATH, search);
}
